import { Injectable } from '@angular/core';

export interface LocationRule { prefix: string; module: string; submodule?: string; }

/**
 * Enfoque A: una entrada por área (no por pantalla), casada por prefijo de URL.
 *
 * Los nombres deben coincidir EXACTAMENTE con el seed de catálogos del backend
 * (migración `Seed_IssueReporting_LocationCatalogs`), porque en este alcance la
 * pre-selección de la cascada casa por `name`.
 */
const RULES: LocationRule[] = [
  { prefix: '/project-management/project/control-items',    module: 'Proyecto', submodule: 'Control de Presupuesto' },
  { prefix: '/project-management/project/progress-tracker', module: 'Proyecto', submodule: 'Avance' },
  { prefix: '/project-management/project/schedule',         module: 'Proyecto', submodule: 'Cronograma' },
  { prefix: '/project-management/project/lps',              module: 'Proyecto', submodule: 'Last Planner' },
  { prefix: '/project-management/project/control-change',   module: 'Proyecto', submodule: 'Control de Cambios' },
  { prefix: '/project-management/project/work-log-manager', module: 'Proyecto', submodule: 'Tareo' },
  { prefix: '/project-management/project/service-contract', module: 'Proyecto', submodule: 'Subcontratos' },
  { prefix: '/project-management/project/daily-report',     module: 'Proyecto', submodule: 'RDO / Informes' },
  { prefix: '/tender/bidding',                              module: 'Licitación', submodule: 'Licitación' },
  { prefix: '/tender/apu-standard',                         module: 'Presupuestos / APU', submodule: 'APU Estándar' },
  { prefix: '/calidad',                                     module: 'Calidad' },
  { prefix: '/human-talent',                                module: 'Talento Humano' },
  { prefix: '/documents',                                   module: 'Control de Documentos' },
  { prefix: '/approvals',                                   module: 'Aprobaciones' },
  { prefix: '/administration',                              module: 'Administración' },
];

@Injectable({ providedIn: 'root' })
export class IssueLocationMapService {

  /** Devuelve la sugerencia del prefijo más largo que hace match, o null. */
  resolve(url: string): { module: string; submodule?: string } | null {
    const normalized = this.normalize(url);

    let best: LocationRule | null = null;
    for (const rule of RULES) {
      if (!normalized.startsWith(rule.prefix)) continue;
      if (!best || rule.prefix.length > best.prefix.length) best = rule;
    }

    return best ? { module: best.module, submodule: best.submodule } : null;
  }

  /** Quita querystring/fragment y los segmentos que son solo un id numérico. */
  private normalize(url: string): string {
    const path = url.split('?')[0].split('#')[0];
    const segments = path.split('/').filter(s => s.length > 0 && !/^\d+$/.test(s));
    return '/' + segments.join('/');
  }
}
